import { css, SerializedStyles } from '@emotion/react';
import { theme } from '@xometry/xometry_loft';

export const resetPasswordStyles: { [key: string]: SerializedStyles } = {
  panel: css`
    margin: 40px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    max-width: 320px;
    min-width: 280px;

    @media (min-width: 600px) {
      margin: 12% auto;
    }
  `,
  button: css`
    border-color: #c1cad1;
    color: #092c47;
    margin-top: ${theme.space[3]};
    width: 100%;

    :hover {
      border-color: #c1cad1;
      color: #092c47;
    }
  `,
};
